import Pusher from 'pusher-js';

import { tokenName } from './useAuth';

let WS_HOST: string | undefined = process.env.VUE_APP_WS_HOST || '';
let WSS_HOST: string | undefined = process.env.VUE_APP_WSS_HOST || WS_HOST;
let WS_PORT: string | number | undefined = process.env.VUE_APP_WS_PORT || 6001;
let WSS_PORT: string | number | undefined = process.env.VUE_APP_WSS_PORT || WS_PORT;
let cluster = '';

if (process.env.VUE_APP_USE_ORIGINAL_PUSHER && process.env.VUE_APP_USE_ORIGINAL_PUSHER === 'true') {
  WS_HOST = undefined;
  WSS_HOST = undefined;
  WS_PORT = undefined;
  WSS_PORT = undefined;
  cluster = 'ap1';
}

export default function useEcho() {
  const pusher = new Pusher(
    process.env.VUE_APP_PUSHER_APP_KEY || '',
    {
      wsHost: WS_HOST,
      wsPort: WS_PORT,
      wssHost: WSS_HOST,
      wssPort: WSS_PORT,
      forceTLS: true,
      // encrypted: true,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
      cluster,
      authEndpoint: `${(process.env.VUE_APP_BACKEND_HOST || 'https://backend-dev.xgen-live.ideavivat-demo.com/api')}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(tokenName)}`,
        },
      },
    } as any,
  );

  return {
    pusher,
  };
}
